import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce } from '@chilecompra/react-kit'
import { DataTable } from '@chilecompra/react-kit/components'
import { exportToCsv } from '../../modules/utils/exports'
// import generateYearsBetween from '../../modules/utils/years'
import { onGetBuyersItemsAndProductsThunk } from './BuyersByItemsAndProductsSection.actions'
import DataLayout, { DataLayoutChild, DataLayoutViews, useDataLayout } from '../../components/Layouts/DataLayout'
import { Description, GridContainer, GridItem, Link, Root, Title } from './BuyersByItemsAndProductsSection.styles'

/**
 * The BuyersByItemsAndProductsSection's container.
 */
const BuyersByItemsAndProductsSection = () => {
  const dispatch = useDispatch()
  const { latestUpdate, loading, yearValue } = useSelector(state => state.topNavbar)
  const { buyers, csv = [] } = useSelector(state => state.buyersByItemsAndProductsSection)
  // const { value: yearValue, onChange: handleChangeYear } = useSelect({
  //   initialValue: endYear,
  //   changeCallback: updatedValue => dispatch(onGetBuyersItemsAndProductsThunk({ year: updatedValue })),
  //   overwriteCallback: () => endYear
  // })
  const hidden = true
  // const { value: currencyValue, onChange: handleChangeCurrency } = useSwitch()
  const {
    disableDownloadFile,
    ref: dataLayoutRef,
    onCaptureImage: handleCaptureImage,
    onChangeView: handleChangeView,
    onDownloadFile: handleDownloadFile
  } = useDataLayout({
    dependencies: [csv, yearValue],
    downloadFileCallback: () => exportToCsv(buyers, `Info_Tamano_Proveedores_${yearValue}`)
  })
  // const yearsOptions = useMemo(() => generateYearsBetween(endYear, startYear), [endYear, startYear])
  // const { value: item1Value, onChange: handleChangeItem1 } = useInput()
  // const { value: item2Value, onChange: handleChangeItem2 } = useInput()
  // const { value: item3Value, onChange: handleChangeItem3 } = useInput()
  // const { value: item4Value, onChange: handleChangeItem4 } = useInput()

  useEffectOnce(() => {
    dispatch(onGetBuyersItemsAndProductsThunk())
  })

  return (
    <Root>
      <GridContainer padding="0 0 23px">
        <GridItem xs={12}>
          <Title>Organismos compradores transando en Mercado Público</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 28px">
        <GridItem xs={12}>
          <Description>Revisa el detalle de montos transados por cada organismo comprador.</Description>
        </GridItem>
      </GridContainer>
      <DataLayout
        disableCaptureImage
        disableChart
        disableDownloadFile={disableDownloadFile}
        header={
          <GridContainer alignItems="center" justifyContent="space-between" spacing={1}>
            {/* <GridItem md={2} xs={12}>
              <Select
                label="año"
                loading={loading}
                options={yearsOptions}
                value={yearValue}
                onChange={handleChangeYear}
              />
            </GridItem> */}
            {/* <GridItem md={2} xs={12}>
              <Switch
                checked={currencyValue}
                color="primary"
                labelLeft="CLP"
                labelRight="USD"
                margin="0 0 0 32px"
                onChange={handleChangeCurrency}
              />
            </GridItem> */}
          </GridContainer>
        }
        initialDisplayedView={DataLayoutViews.TABLE}
        noDataText="No hay datos de organismos compradores para los filtros seleccionados."
        ref={dataLayoutRef}
        updatedDate={latestUpdate}
        hidden={hidden}
        onCaptureImage={handleCaptureImage}
        onChangeView={handleChangeView}
        onDownloadFile={handleDownloadFile}
      >
        <DataLayoutChild view={DataLayoutViews.TABLE}>
          <GridContainer justifyContent="center" padding="0 0 20px" style={{ marginTop: `-25px` }}>
            <GridItem xs={12}>
              <DataTable
                header={
                  <GridContainer alignItems="center" height="100%">
                    <GridItem md={5} xs={12}>
                      {/* <Popover hidden anchor={<Button variant="outlined">+ Añadir filtro</Button>}>
                        <PopoverContent>
                          <GridContainer>
                            <GridItem xs={12}>
                              <Tabs value="buyers-items-level-1">
                                <Tab id="buyers-items-level-1" label="Rubros Nivel 1">
                                  <GridContainer>
                                    <GridItem xs={12}>
                                      <Input
                                        placeholder="Ingresa o selecciona el rubro"
                                        value={item1Value}
                                        onChange={handleChangeItem1}
                                      />
                                    </GridItem>
                                  </GridContainer>
                                </Tab>
                                <Tab id="buyers-items-level-2" label="Rubros Nivel 2">
                                  <GridContainer>
                                    <GridItem xs={12}>
                                      <Input
                                        placeholder="Ingresa o selecciona el rubro"
                                        value={item2Value}
                                        onChange={handleChangeItem2}
                                      />
                                    </GridItem>
                                  </GridContainer>
                                </Tab>
                                <Tab id="buyers-items-level-3" label="Rubros Nivel 3">
                                  <GridContainer>
                                    <GridItem xs={12}>
                                      <Input
                                        placeholder="Ingresa o selecciona el rubro"
                                        value={item3Value}
                                        onChange={handleChangeItem3}
                                      />
                                    </GridItem>
                                  </GridContainer>
                                </Tab>
                                <Tab id="buyers-items-level-4" label="Rubros Nivel 4">
                                  <GridContainer>
                                    <GridItem xs={12}>
                                      <Input
                                        placeholder="Ingresa o selecciona el rubro"
                                        value={item4Value}
                                        onChange={handleChangeItem4}
                                      />
                                    </GridItem>
                                  </GridContainer>
                                </Tab>
                              </Tabs>
                            </GridItem>
                          </GridContainer>
                        </PopoverContent>
                      </Popover> */}
                    </GridItem>
                    <GridItem md={7} xs={12} />
                  </GridContainer>
                }
                headers={[
                  { label: 'Nombre', value: 0 },
                  { label: 'Sector', value: 1 },
                  { label: 'Acciones', value: 'actions' }
                ]}
                headersCellsProps={[
                  { enableFilter: true, enableSort: true, width: '60%' },
                  { enableFilter: true, enableSort: true, width: '30%' },
                  { width: '10%' }
                ]}
                loading={loading}
                records={buyers}
                recordsDecorators={[
                  ([name]) => name,
                  ([, sector]) => sector,
                  ([, , id]) => <Link to={`/ficha-organismo/${id}`}>Ver ficha</Link>
                ]}
              />
            </GridItem>
          </GridContainer>
        </DataLayoutChild>
      </DataLayout>
    </Root>
  )
}

export default BuyersByItemsAndProductsSection
